export const PERMS = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
  DELETE: 'delete'
}

export const PERMISSION_MODULE_IDS = {
  'map': 1,
  'threads': 2,
  'balance': 3,
  'targets': 4,
  'garbage-source': 5,
  'msn': 6,
  'unauth-heap': 7,
  'tko-object': 8,
  'tko-operator': 9,
  'agreement': 10,
  'analytic': 11,
  'fkko': 12,
  'groro': 13,
  'tech': 14,
  'garbage-bank': 15,
  'administration': 16,
  'import': 17
}

export const PERMS_SERVER = {
  VIEW: 'read'
}

export const PERMS_SERVER_CONFIG = {
  [PERMS_SERVER.VIEW]: {
    label: 'Просмотр'
  },
  create: {
    label: 'Добавление'
  },
  update: {
    label: 'Редактирование'
  },
  delete: {
    label: 'Удаление'
  }
}

export const GUEST_SERVER_PERMISSION = ['geo.view']

export const PERMISSIONS_MAP = {
  'equidistant.object': {
    permissions: {
      view: 'map-read'
    }
  },
  'equidistant.object.geo': {
    permissions: {
      view: 'map-read'
    }
  },
  customRule: {
    name: 'Разрешение на вывод навзвания региона в тулбаре',
    prefix: null,
    permissions: {
      'show-site-name': 'show-site-name'
    }
  },
  import: {
    name: 'Импорт данных',
    prefix: 'import',
    permissions: {
      view: 'import-read', create: 'import-create', edit: 'import-update', delete: 'import-delete'
    }
  },
  'registry.operators': {
    name: 'Реестр операторов по обращению с отходами',
    prefix: 'tko-operator',
    permissions: {
      create: 'tko-operator-create',
      edit: 'tko-operator-update',
      view: 'tko-operator-read',
      delete: 'tko-operator-delete'
    }
  },
  'regionalOperators': {
    name: 'Реестр операторов по обращению с отходами',
    prefix: 'tko-operator',
    permissions: {
      create: 'tko-operator-create',
      edit: 'tko-operator-update',
      view: 'tko-operator-read',
      delete: 'tko-operator-delete'
    }
  },
  'geo.objects': {
    name: 'Карта объектов',
    prefix: 'map',
    permissions: {
      create: 'map-create', edit: 'map-update', view: 'map-read', delete: 'map-delete'
    }
  },
  'geo.apos': {
    name: 'Зоны деятельности',
    prefix: 'map',
    permissions: {
      create: 'map-create', edit: 'map-update', view: 'map-read', delete: 'map-delete'
    }
  },
  'geo.treads': {
    name: 'Схема потоков',
    prefix: 'threads',
    permissions: {
      create: 'threads-create', edit: 'threads-update', view: 'threads-read', delete: 'threads-delete'
    }
  },
  'geo.forecasts': {
    name: 'Прогнозирование',
    prefix: 'threads',
    permissions: {
      create: 'threads-create', edit: 'threads-update', view: 'threads-read', delete: 'threads-delete'
    }
  },
  target: {
    name: 'Целевые показатели',
    prefix: 'targets',
    permissions: {
      create: 'targets-create', edit: 'targets-update', view: 'targets-read', delete: 'targets-delete'
    }
  },
  garbage: {
    name: 'Отходообразователи',
    prefix: 'garbage-source',
    permissions: {
      create: 'garbage-source-create',
      edit: 'garbage-source-update',
      view: 'garbage-source-read',
      delete: 'garbage-source-delete'
    }
  },
  msn: {
    prefix: 'msn',
    name: 'МСиН',
    permissions: {
      create: 'msn-create', edit: 'msn-update', view: 'msn-read', delete: 'msn-delete'
    }
  },
  unauthorized: {
    name: 'Несанкционированные свалки',
    prefix: 'unauth-heap',
    permissions: {
      create: 'unauth-heap-create', edit: 'unauth-heap-update', view: 'unauth-heap-read', delete: 'unauth-heap-delete'
    }
  },
  garbageObjectRegistry: {
    name: 'Реестр объектов по обращению с отходами',
    prefix: 'tko-object',
    permissions: {
      create: 'tko-object-create',
      edit: 'tko-object-update',
      view: 'tko-object-read',
      delete: 'tko-object-delete'
    }
  },
  'registry.contracts': {
    name: 'Реестр договоров',
    prefix: 'agreement',
    permissions: {
      create: 'agreement-create',
      edit: 'agreement-update',
      view: 'agreement-read',
      delete: 'agreement-delete'
    }
  },
  'contracts.contracts': {
    name: 'Реестр договоров',
    prefix: 'agreement',
    permissions: {
      create: 'agreement-create',
      edit: 'agreement-update',
      view: 'agreement-read',
      delete: 'agreement-delete'
    }
  },
  analytic: {
    name: 'Аналитика',
    prefix: 'analytic',
    permissions: {
      create: 'analytic-create', edit: 'analytic-update', view: 'analytic-read', delete: 'analytic-delete'
    }
  },
  'classifier.fkko': {
    name: 'ФККО',
    prefix: 'fkko',
    permissions: {
      create: 'fkko-create', edit: 'fkko-update', view: 'fkko-read', delete: 'fkko-delete'
    }
  },
  'classifier.groro': {
    name: 'ГРОРО',
    prefix: 'groro',
    permissions: {
      create: 'groro-create', edit: 'groro-update', view: 'groro-read', delete: 'groro-delete'
    }
  },
  'classifier.tech': {
    name: 'Банк данных технологий',
    prefix: 'tech',
    permissions: {
      create: 'tech-create', edit: 'tech-update', view: 'tech-read', delete: 'tech-delete'
    }
  },
  'classifier.garbage': {
    name: 'Банк данных об отходах',
    prefix: 'garbage-bank',
    permissions: {
      create: 'garbage-bank-create',
      edit: 'garbage-bank-update',
      view: 'garbage-bank-read',
      delete: 'garbage-bank-delete'
    }
  },
  atu: {
    name: 'Административно-территориальное устройство',
    prefix: 'administration',
    permissions: {
      create: 'administration-create',
      edit: 'administration-update',
      view: 'administration-read',
      delete: 'administration-delete'
    }
  },
  access: {
    name: 'Администрирование',
    
    prefix: 'administration',
    permissions: {
      create: 'administration-create',
      edit: 'administration-update',
      view: 'administration-read',
      delete: 'administration-delete'
    }
  },
  // system perms
  account: {
    name: 'Личный кабинет',
    prefix: 'profile',
    permissions: {
      create: 'profile-create', edit: 'profile-update', view: 'profile-read', delete: 'profile-delete'
    }
  },
  development: {
    name: 'Разработка',
    prefix: 'development',
    permissions: {
      create: 'development-create', edit: 'development-update', view: 'development-read', delete: 'development-delete'
    }
  },
  citizen: {
    name: 'Обращения граждан',
    prefix: 'citizen',
    permissions: {
      create: 'citizen-create', edit: 'citizen-update', view: 'citizen-read', delete: 'citizen-delete'
    }
  },
  navigationControl: {
    name: 'Навигационный контроль',
    prefix: 'navigationControl',
    permissions: {
      create: 'navigationControl-create',
      edit: 'navigationControl-update',
      view: 'navigationControl-read',
      delete: 'navigationControl-delete'
    }
  },
  billing: {
    name: 'Биллинг',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'billing.tariff': {
    name: 'Тарифы',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'billing.bank': {
    name: 'Банки',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'bankPackets': {
    name: 'Банковские пачки',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'groupOperations': {
    name: 'Групповые операции',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'invoiceControl': {
    name: 'Контроль счетов',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'normative': {
    name: 'Нормативы',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'wasteGenerators': {
    name: 'Потребители услуг',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'wasteGeneratorsBills': {
    name: 'Реестр лицевых счетов',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'payment': {
    name: 'Начисление',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'payment.payments': {
    name: 'Ввод платежей',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  'individuals': {
    name: 'Реестр физических лиц',
    prefix: 'billing',
    permissions: {
      create: 'billing-create', edit: 'billing-update', view: 'billing-read', delete: 'billing-delete'
    }
  },
  waybill: {
    name: 'Путевые листы',
    prefix: 'waybill',
    permissions: {
      create: 'waybill-create', edit: 'waybill-update', view: 'waybill-read', delete: 'waybill-delete'
    }
  },
  calculation: {
    name: 'Тарифы',
    prefix: 'calculation',
    permissions: {
      create: 'calculation-create', edit: 'calculation-update', view: 'calculation-read', delete: 'calculation-delete'
    }
  },
  sourcesWaste: {
    name: 'Тарифы',
    prefix: 'sourcesWaste',
    permissions: {
      create: 'sourcesWaste-create',
      edit: 'sourcesWaste-update',
      view: 'sourcesWaste-read',
      delete: 'sourcesWaste-delete'
    }
  },
  carPark: {
    name: 'Автопарк',
    prefix: 'carPark',
    permissions: {
      create: 'carPark-create', edit: 'carPark-update', view: 'carPark-read', delete: 'carPark-delete'
    }
  },
  staffManagement: {
    name: 'Управление персоналом',
    prefix: 'staffManagement',
    permissions: {
      create: 'staffManagement-create',
      edit: 'staffManagement-update',
      view: 'staffManagement-read',
      delete: 'staffManagement-delete'
    }
  },
  routes: {
    name: 'Маршруты',
    prefix: 'routes',
    permissions: {
      create: 'routes-create', edit: 'routes-update', view: 'routes-read', delete: 'routes-delete'
    }
  }
}

export const PERMS_ALL = [
  // demo
  'routes-create', 'routes-update', 'routes-read', 'routes-delete',
  'staffManagement-create', 'staffManagement-update', 'staffManagement-read', 'staffManagement-delete',
  'carPark-create', 'carPark-update', 'carPark-read', 'carPark-delete',
  'sourcesWaste-create', 'sourcesWaste-update', 'sourcesWaste-read', 'sourcesWaste-delete',
  'calculation-create', 'calculation-update', 'calculation-read', 'calculation-delete', 'waybill-create', 'waybill-update', 'waybill-read', 'waybill-delete', 'navigationControl-create', 'navigationControl-update', 'navigationControl-read', 'navigationControl-delete', 'citizen-create', 'citizen-update', 'citizen-read', 'citizen-delete', 'billing-create', 'billing-update', 'billing-read', 'billing-delete',
  // no demo
  'administration-create', 'administration-update', 'administration-read', 'administration-delete', 'admin', 'map-read', 'map-create', 'map-update', 'map-delete', 'threads-read', 'threads-create', 'threads-update', 'threads-delete', 'balance-read', 'balance-create', 'balance-update', 'balance-delete', 'targets-read', 'targets-create', 'targets-update', 'targets-delete', 'garbage-source-read', 'garbage-source-create', 'garbage-source-update', 'garbage-source-delete', 'msn-read', 'msn-create', 'msn-update', 'msn-delete', 'unauth-heap-read', 'unauth-heap-create', 'unauth-heap-update', 'unauth-heap-delete', 'tko-object-read', 'tko-object-create', 'tko-object-update', 'tko-object-delete', 'agreement-read', 'agreement-create', 'agreement-update', 'agreement-delete', 'analytic-read', 'analytic-create', 'analytic-update', 'analytic-delete', 'fkko-read', 'fkko-create', 'fkko-update', 'fkko-delete', 'groro-read', 'groro-create', 'groro-update', 'groro-delete', 'tech-read', 'tech-create', 'tech-update', 'tech-delete', 'garbage-bank-read', 'garbage-bank-create', 'garbage-bank-update', 'garbage-bank-delete', 'administration-read', 'administration-create', 'administration-update', 'import-read', 'import-create', 'import-update', 'import-delete', 'tko-operator-read', 'tko-operator-create', 'tko-operator-update', 'tko-operator-delete', 'administration-delete'
]

export const SYSTEM_PERMS = [
  // demo
  'routes-create', 'routes-update', 'routes-read', 'routes-delete',
  'staffManagement-create', 'staffManagement-update', 'staffManagement-read', 'staffManagement-delete',
  'carPark-create', 'carPark-update', 'carPark-read', 'carPark-delete',
  'sourcesWaste-create', 'sourcesWaste-update', 'sourcesWaste-read', 'sourcesWaste-delete',
  'calculation-create', 'calculation-update', 'calculation-read', 'calculation-delete', 'waybill-create', 'waybill-update', 'waybill-read', 'waybill-delete', 'navigationControl-create', 'navigationControl-update', 'navigationControl-read', 'navigationControl-delete', 'citizen-create', 'citizen-update', 'citizen-read', 'citizen-delete', 'billing-create', 'billing-update', 'billing-read', 'billing-delete',
  // no demo
  'development-create', 'development-update', 'development-read', 'development-delete', 'profile-create', 'profile-update', 'profile-read', 'profile-delete'
]
